export function coloredDebug(condition: boolean) {
  console.debug(
    `%c Will Return ${condition}!`,
    `background: #222; color: ${condition ? '#bada55' : '#fe5757'}`,
  );
}
